import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      userId: "",
      name: "",
      avater:"",
      logined: false,
      loginShow: false,
      registerShow: false,
      changePasswordShow: false,
      // token: 'a84a40c81f784490a4c5689187054aa1',//这个只在access中使用了。。。无语了
      token: 'a84a38c81d784965a4a5321139066a1m',
      vipLevel:'0',//会员等级（非会员0、认证会员1、生态会员2、过期的生态会员3）
      vipType:'0',//会员类别（企业会员1、科研会员2）
      vipActivityStatus:'',//会员等级（贵宾1、非贵宾!=1）
    },
    pageYOffset: 0,
    innerHeight: 0,
    poiSelected: false, //searchBar
    longitude: "",
    latitude: "",
    loginDialog: false,
    personCenter: {
      nodeId: "userInfo",
    },
    prefectDialog: false,
    prefectAlert: false,
    prefectAlertType: 0,
    prefectAlertText: "",
    curTab: "image",
    agentRepeat:0,

    //access
    pay: {
      price: "",
      payId: "",
      picture: ""
    },
    windowSize: {
      x: 0,
      y: 0,
    },
    map: {
      mapUrl: 'https://t{s}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk=7673ab811ff9ac584d31d1958b728583',
      infoUrl: 'https://t{s}.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=7673ab811ff9ac584d31d1958b728583',
      // mapUrl: 'https://t{s}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk=05861044e5fe4135647facbd39abc543',
      // infoUrl: 'https://t{s}.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=05861044e5fe4135647facbd39abc543',
      mapSubdomains: { subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'] },
    },
    search: {
      favoriteShow: false,
      favorite: [
        {
          "id": 7,
          "uuid": null,
          "name": "测试6",
          "geo": { "features": [{ "geometry": { "coordinates": [[[71.71875, 45.583289756006316], [83.671875, 39.36827914916014], [100.8984375, 49.83798245308484], [90.703125, 53.12040528310657], [71.71875, 45.583289756006316]]], "type": "Polygon" }, "type": "Feature", "properties": {} }, { "geometry": { "coordinates": [[126.21093749999999, 46.800059446787316], [118.47656249999999, 40.44694705960048], [113.203125, 39.639537564366684]], "type": "LineString" }, "type": "Feature", "properties": {} }], "type": "FeatureCollection" },
          "type": "file",
          "userId": null
        },
        {
          "id": 11,
          "uuid": null,
          "name": "测试16",
          "geo": { "features": [{ "geometry": { "coordinates": [[48.1640625, 56.36525013685606], [93.8671875, 59.88893689676585]], "type": "LineString" }, "type": "Feature", "properties": {} }], "type": "FeatureCollection" },
          "type": "linestring",
          "userId": null
        }
      ],
      favoriteSelected: [],

      measure: [],
      cartShow: false,
      cartSelected: [],
      targetSelecting: false,
      currentType: 1,
      typeInfoStore: [/* { areaCoverGeo: '' }, */ { areaCoverGeo: '' }, { areaCoverGeo: '' }, { areaCoverGeo: '' }, { areaCoverGeo: '' }],
      currentItem: {},
      productTypeStore: [],
      selected: [],
      ordered: [],
      longitude: '',
      latitude: '',
      targetType: 'draw',
      resultsStore: {
        // generalOptics: {"currentPage":1,"order":"asc","pagesize":40,"records":[{"price":10000,"bandAmount":5,"bandString":"B,G,R,NIR,PAN","centerLatitude":38.7963,"centerLongitude":116.404,"cloudPercent":0,"id":5444621,"imageGeo":"{\"type\":\"Polygon\",\"coordinates\":[[[116.45,38.9056],[116.543,38.7597],[116.357,38.6872],[116.264,38.8329],[116.45,38.9056]]]}","imageGsd":1.06,"imagingTime":"2020-01-03 14:55:14","productBand":"PMS","productId":"JL101D_PMS_20200103145513_200020278_103_0001_001_L1","productQuality":"D","productType":1,"rollSatelliteAngle":0.64,"satelliteId":"JL101D","sensor":"PMS","solarElevation":18.2233,"thumbnail":"/thumbnail/JL101D_PMS_20200103145513_200020278_103_0001_001_L1_MSS.jpg"},{"price":10000,"bandAmount":5,"bandString":"PAN,B,G,R,NIR","centerLatitude":38.7966,"centerLongitude":116.373,"cloudPercent":0,"id":5273488,"imageGeo":"{\"type\":\"Polygon\",\"coordinates\":[[[116.421,38.9056],[116.514,38.7582],[116.325,38.6875],[116.232,38.8347],[116.421,38.9056]]]}","imageGsd":1,"imagingTime":"2019-11-10 13:25:46","productBand":"PMS","productId":"JL101D_PMS_20191110132545_200018284_102_0001_001_L1","productQuality":"D","productType":1,"rollSatelliteAngle":-3.7,"satelliteId":"JL101D","sensor":"PMS","solarElevation":30.5187,"thumbnail":"/thumbnail/JL101D_PMS_20191110132545_200018284_102_0001_001_L1_MSS.jpg"},{"price":10000,"bandAmount":6,"bandString":"B,G,R,RE,NIR,PAN","centerLatitude":38.8184,"centerLongitude":116.332,"cloudPercent":1,"id":4599392,"imageGeo":"{\"type\":\"Polygon\",\"coordinates\":[[[116.405,38.8567],[116.286,38.8771],[116.259,38.78],[116.378,38.7596],[116.405,38.8567]]]}","imageGsd":0.92,"imagingTime":"2019-09-05 12:29:15","productBand":"PMS","productId":"JL104B_PMS2_20190905122900_200016395_101_0011_001_L1","productQuality":"A","productType":1,"rollSatelliteAngle":3.63,"satelliteId":"JL104B","sensor":"PMS2","solarElevation":57.8855,"thumbnail":"/thumbnail/JL104B_PMS2_20190905122900_200016395_101_0011_001_L1_MSS.jpg"},{"price":10000,"bandAmount":5,"bandString":"B,G,R,NIR,PAN","centerLatitude":38.8322,"centerLongitude":116.428,"cloudPercent":81,"id":3275866,"imageGeo":"{\"type\":\"Polygon\",\"coordinates\":[[[116.478,38.9428],[116.569,38.7921],[116.378,38.7213],[116.287,38.8718],[116.478,38.9428]]]}","imageGsd":1.01,"imagingTime":"2019-07-08 17:15:42","productBand":"PMS","productId":"JL101D_PMS_20190708171538_200014889_102_0002_001_L1","productQuality":"A","productType":1,"rollSatelliteAngle":-5.8,"satelliteId":"JL101D","sensor":"PMS","solarElevation":25.9016,"thumbnail":"/thumbnail/JL101D_PMS_20190708171538_200014889_102_0002_001_L1_MSS.jpg"},{"price":10000,"bandAmount":6,"bandString":"B,G,R,RE,NIR,PAN","centerLatitude":38.8415,"centerLongitude":116.316,"cloudPercent":100,"id":3814024,"imageGeo":"{\"type\":\"Polygon\",\"coordinates\":[[[116.4,38.8763],[116.263,38.9027],[116.233,38.8066],[116.369,38.7802],[116.4,38.8763]]]}","imageGsd":1.02,"imagingTime":"2018-04-25 12:45:57","productBand":"PMS","productId":"JL104B_PMS1_20180425124550_200002389_101_0005_002_L1","productQuality":"A","productType":1,"rollSatelliteAngle":-18.87,"satelliteId":"JL104B","sensor":"PMS1","solarElevation":63.2399,"thumbnail":"/thumbnail/JL104B_PMS1_20180425124550_200002389_101_0005_002_L1_MSS.jpg"},{"price":10000,"bandAmount":6,"bandString":"PAN,B,G,R,RE,NIR","centerLatitude":38.8922,"centerLongitude":116.403,"cloudPercent":1,"id":4048218,"imageGeo":"{\"type\":\"Polygon\",\"coordinates\":[[[116.477,38.8886],[116.331,38.9087],[116.304,38.7993],[116.45,38.7792],[116.477,38.8886]]]}","imageGsd":1.28,"imagingTime":"2018-01-23 12:27:03","productBand":"PMS","productId":"JL104B_PMS2_20180123122646_200000735_103_0011_002_L1","productQuality":"D","productType":1,"rollSatelliteAngle":22.73,"satelliteId":"JL104B","sensor":"PMS2","solarElevation":31.6458,"thumbnail":"/thumbnail/JL104B_PMS2_20180123122646_200000735_103_0011_002_L1_MSS.jpg"},{"price":10000,"bandAmount":3,"bandString":"BGR","centerLatitude":38.811246,"centerLongitude":116.427279,"cloudPercent":0,"id":4183343,"imageGeo":"{\"type\":\"Polygon\",\"coordinates\":[[[116.342931,38.906358],[116.569847,38.858099],[116.513464,38.715661],[116.286947,38.763798],[116.342931,38.906358]]]}","imageGsd":4.94,"imagingTime":"2016-05-13 11:37:47","productBand":"PMS","productId":"JL101A_PMS_20160513113712_000008585_105_0019_004_L1","productQuality":"D","productType":1,"rollSatelliteAngle":36.92,"satelliteId":"JL101A","sensor":"PMS","solarElevation":68.380088,"thumbnail":"/thumbnail/JL101A_PMS_20160513113712_000008585_105_0019_004_L1_MSS.jpg"}],"totalPages":"1","totalSize":"7"},
        generalOptics: { records: [], totalSize: 0 },
        luminous: { records: [], totalSize: 0 },
        video: { records: [], totalSize: 0 },
        multispectral: { records: [], totalSize: 0 },
        // halfMeter: { records: [], totalSize: 0 },
      },
      selectedRangeStore: {
        upload: '',
        china: '',
        world: '',
        point: '',
        draw: '',
        coordinatesArray: '',
        rectangle: '',
        circle: ''
      },
      selectedType: 'generalOptics',//导航栏选择的存档影像类型
      relaxOrderId: '',//智慧模式的订单id，用于重新下单
      relaxUserId: '',//智慧模式的用户id，用于重新下单
      manageName: '',//商务经理名字（管理端编程摄影的商务经理username）
      easyName: '',//智慧模式的订单需求名称
      
      programOrderId: '',//编程摄影的订单id，用于重新下单
      multiId: '',//编程摄影的多期订单单独的id，用于重新下单
      programName: '',//编程摄影的订单需求名称
      geoStr: '',//编程摄影的裁剪范围
      customerAccount: '',//编程摄影传来的客户账号
      // manageName: '',//管理端编程摄影的商务经理username
      // standardProduct: {
      //   productId: '',
      //   satelliteId: ['JL101A', 'JL101E,JL102E,JL1GF02A,JL1GF02B', 'JL101K,JL1KF01A', 'JL103B', 'JL104B,JL105B,JL106B,JL107B,JL108B', 'JL101D,JL1GF03A', 'JL101C,JL102C,JL1GP01,JL1GP02', 'JL1GF03B01,JL1GF03B02,JL1GF03B03,JL1GF03B04,JL1GF03B05,JL1GF03B06', 'JL1GF03C01,JL1GF03C02,JL1GF03C03'],
      //   imageGsd: '',
      //   productType: [1, 2, 3, 4],
      //   productBand: [],
      //   cloudPercent: 25,
      //   rollSatelliteAngle: 45,
      //   startTime: '',
      //   endTime: ''
      // },
      standardProduct: {
        productId: '',
        trPlanId: '',
        satelliteId: [
          'JL101A', 'JL1GF02A', 'JL1GF02B', 'JL1KF01A', 'JL1KF01B',
          'JL1GF03A', 'JL103B', 'JL104B', 'JL105B', 'JL106B',
          'JL107B', 'JL108B', 'JL1GF03B01', 'JL1GF03B02', 'JL1GF03B03',
          'JL1GF03B04', 'JL1GF03B05', 'JL1GF03B06', 'JL1GF03C01', 'JL1GF03C02',
          'JL1GF03C03', 'JL1GP01', 'JL1GP02', 'JL1GF03D01', 'JL1GF03D02',
          'JL1GF03D03',
          //新增的
          'JL1KF01C','JL1GF04A', 'JL1GF02D', 'JL1GF02F', 'JL1GF03D04', 'JL1GF03D05', 'JL1GF03D06', 'JL1GF03D07', 'JL1GF03D08', 'JL1GF03D10', 'JL1GF03D11', 'JL1GF03D12', 'JL1GF03D13', 'JL1GF03D14', 'JL1GF03D15', 'JL1GF03D16', 'JL1GF03D17', 'JL1GF03D18', 'JL1GF03D27', 'JL1GF03D28', 'JL1GF03D29', 'JL1GF03D30', 'JL1GF03D31', 'JL1GF03D32' , 'JL1GF03D33'
          // // 'XSD-10',
          // 'JL1MF01A01',

        ],
        satelliteIdNames:{},
        imageGsd: '',
        productType: [1, 2, 3, 4],
        productBand: [],
        cloudPercent: 100,
        rollSatelliteAngle: 45,
        startTime: '',
        endTime: '',
        quality: ['A', 'B', 'C,D'],
        // quality: ['A', 'B', 'C', 'D'],
        qualitySelectedItem: 'A',
        sensitive: [],
        accessible: '',
        sensor: ['PMS1,PMS2', 'SWIR', 'MWIR', 'LWIR1,LWIR2'],

        // ifDemandSensitive: true,
        // ifRegionSensitive: true,
        // ifNoSensitive: true,
        // sensitiveArray: ['1', '2', '0'],//敏感
        // ifff: true,//建议分发
        // ifnff: true,//不建议分发
      },
    },
    myOrder: {
      show: true,
      mapSelected: '',
    },
    AisLibrary: {
      aisStartTime: '2019-01-01',//AIS时空查询开始时间
      aisEndTime: new Date().toISOString().substr(0, 10),//AIS时空查询结束时间,
      aisSelectedRange: '',
      drawStart: false,
      targetType: 0,
    },
    programSubmit: {
      file: "",
      filename: "",
      targetType: 'draw',
      selectedRangeStore: {
        upload: '',
        china: '',
        world: '',
        point: '',
        draw: '',
        coordinatesArray: '',
        rectangle: '',
        circle: ''
      },
      area: 0,
      reselectOrPreview: "reselect",
      uploadFileName: "",
      selectAreaName: "",
      token: 'a84a9012cf784690a4c5689187054aa0',
    },
    invoice: {
      invoiceShow: false,
      invoicePage: 1,
      billDepartmentName1: '',
      invoiceInfo1: {
        type: '1',
        code: '',
        address: '',
        bank: '',
        account: '',
        phone: '',
        addressee: '',
        addresseePhone: '',
        addressDetail: '',
      },
      provinceItems1: [],
      cityItems1: [],
      countyItems1: [],
      addressProvince1: '',
      addressCity1: '',
      addressCounty1: '',
      invoiceFlag: false,
      type: 0,
      money: '',
      id: '',
      billDefault: 0,
      addressDefault: 0,
    },
    mode:0,
  },
  mutations: {

  },
  actions: {},
});
